import { motion, AnimatePresence } from "framer-motion";
import { FaTimes, FaTrash } from "react-icons/fa";
import { useCart } from "../../context/CartContext";
import { Link } from "react-router-dom";

const getImageSrc = (url) => {
  if (!url) return "/placeholder.jpg";
  if (url.startsWith("/uploads")) return `http://localhost:5000${url}`;
  return url;
};

export default function CartDrawer() {
  const { cart, isCartOpen, setIsCartOpen, removeFromCart, cartTotal } = useCart();

  return (
    <AnimatePresence>
      {isCartOpen && (
        <>
          <motion.div
            className="fixed inset-0 bg-black/60 z-40"
            onClick={() => setIsCartOpen(false)}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          />
          <motion.div
            initial={{ x: "-100%" }}
            animate={{ x: 0 }}
            exit={{ x: "-100%" }}
            transition={{ type: "tween", duration: 0.3 }}
            className="fixed left-0 top-0 h-full w-[380px] bg-neutral-950 border-r border-neutral-800 z-50 flex flex-col"
          >
            {/* Header */}
            <div className="flex items-center justify-between p-5 border-b border-neutral-800">
              <h2 className="text-white font-bold text-xl">السلة</h2>
              <button onClick={() => setIsCartOpen(false)} className="text-white hover:text-red-500">
                <FaTimes size={20} />
              </button>
            </div>

            {/* Items */}
            <div className="flex-1 overflow-y-auto p-4 space-y-4">
              {cart.length === 0 ? (
                <p className="text-neutral-500 text-center mt-10">السلة فارغة</p>
              ) : (
                cart.map((item) => (
                  <div key={item.id} className="flex gap-3 bg-neutral-900 p-3 rounded-xl border border-neutral-800">
                    <img
                      src={getImageSrc(item.image_url || item.image)}
                      alt={item.name}
                      className="w-16 h-16 object-cover rounded-lg"
                    />
                    <div className="flex-1">
                      <h3 className="text-white text-sm font-bold">{item.name}</h3>
                      <p className="text-neutral-400 text-xs">
                        {item.quantity} × {item.price} ₪
                      </p>
                    </div>
                    <button
                      onClick={() => removeFromCart(item.id)}
                      className="text-neutral-500 hover:text-red-500 transition"
                    >
                      <FaTrash size={16} />
                    </button>
                  </div>
                ))
              )}
            </div>

            {/* Footer – only show when cart has items */}
{cart.length > 0 && (
  <div className="border-t border-neutral-800 p-5 space-y-4">
    <div className="flex justify-between text-white font-bold">
      <span>المجموع</span>
      <span>{cartTotal} ₪</span>
    </div>
    <p className="text-sm text-neutral-400">
      الشحن مجاني للطلبات فوق 500 ₪
    </p>
    <Link
      to="/checkout"
      onClick={() => setIsCartOpen(false)}
      className="block w-full bg-red-600 hover:bg-red-700 text-white py-3 rounded-xl font-bold text-center transition"
    >
      إتمام الطلب
    </Link>
  </div>
)}
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}